import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import AImageWBlack from '../../images/A-negro.svg';

import '../../styles/nav.scss'; 

class HomeHeader extends Component {

	state = {
		isMenuOpen: false,
	}

	toggleMenu = (e) => {
		let target = event.target;
		if(target.tagName.toLowerCase() === 'a' 
			|| target.classList.contains('menu-x')
			|| target.tagName.toLowerCase() === 'span') {
			this.setState({isMenuOpen: !this.state.isMenuOpen})
		}
	}
	render() {
		return (
			<div className={this.state.isMenuOpen? 'open': ''} style={NavDiv}>
				<nav className='nav-mobile' onClick={this.toggleMenu}>
					<p><Link to='/'> Home</Link></p>
					<p><Link to='/projects'> Projects</Link></p>
					<p><Link to='/skills'> Skills</Link></p>
					<p><Link to='/employment'> Employment</Link></p>
					<p><Link to='/contact'> Contact </Link></p>
				</nav>
				<div className='mobile-header'>
					<AImageWBlack className='menu-A' />
					<div className='menu-x' onClick={this.toggleMenu}>
	                  <span ></span>
	                </div>
				</div>
			</div>
		)
	}
}

const NavDiv = {
	position: 'absolute',
	zIndex: 1,
	width: '100%'
}

export default HomeHeader;
